import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import whiteOwlLogo from '../assets/LOGO WHITE.png';

// Shared top nav — visually identical to the homepage (NewHome.js) nav bar.
// Used on secondary pages (Terms, Privacy) so the whole site shares one look.
const NAV_STYLES = `
.wo-site-nav{position:fixed;top:0;left:0;right:0;z-index:50;display:flex;align-items:center;justify-content:space-between;padding:20px 48px;background:linear-gradient(180deg,rgba(12,22,48,.94),rgba(12,22,48,.82));backdrop-filter:blur(6px);font-family:'Instrument Sans',sans-serif}
.wo-site-nav .logo{display:flex;align-items:center;gap:10px;color:#EFF3FB;font-weight:600;font-size:1.05rem;letter-spacing:.02em}
.wo-site-nav .logo img{height:28px;width:auto;cursor:pointer}
.wo-site-nav .nav-links{display:flex;gap:28px;align-items:center}
.wo-site-nav .nav-links a{color:#EFF3FB;text-decoration:none;font-size:.92rem;opacity:.85}
.wo-site-nav .nav-links a:hover{opacity:1}
.wo-site-nav .btn{display:inline-block;padding:11px 22px;border-radius:999px;font-weight:600;font-size:.92rem;text-decoration:none;cursor:pointer;border:none;transition:transform .15s ease}
.wo-site-nav .btn:hover{transform:translateY(-1px)}
.wo-site-nav .btn-orange{background:linear-gradient(135deg,#E8862E,#F5A94B);color:#17224A;box-shadow:0 4px 18px rgba(232,134,46,.45)}
.wo-site-nav .btn-ghost{background:transparent;color:#EFF3FB;border:1px solid rgba(250,250,251,.35)}
@media (max-width:820px){.wo-site-nav{padding:16px 20px}.wo-site-nav .nav-links a:not(.btn){display:none}}
`;

const SiteNav = () => {
  const { pathname } = useLocation();
  // On the homepage "#steps" scrolls in place; elsewhere it needs to land back on "/" first.
  const homeAnchor = pathname === '/' ? '' : '/';

  return (
    <nav className="wo-site-nav">
      <style>{NAV_STYLES}</style>
      <div className="logo">
        <Link to="/"><img src={whiteOwlLogo} alt="WhiteOwl" /></Link>
      </div>
      <div className="nav-links">
        <a href={`${homeAnchor}#steps`}>How it works</a>
        <a href={`${homeAnchor}#pricing`}>Pricing</a>
        <a href="#">The Edge</a>
        <a href="#" className="btn btn-ghost">Sign in</a>
        <a href="#" className="btn btn-orange">Buy now</a>
      </div>
    </nav>
  );
};

export default SiteNav;
